var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationIconGenreEssentials({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "24px-genre-essentials-01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 13,
    width: 8,
    height: 2,
    fill: "#343434"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,4H13V15h7Zm-2,9H15V6h3Z",
    fill: "#343434"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8,12A4,4,0,1,0,4,8,4,4,0,0,0,8,12ZM8,6A2,2,0,1,1,6,8,2,2,0,0,1,8,6Z",
    fill: "#343434"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21,1H3A2,2,0,0,0,1,3V17a2,2,0,0,0,2,2h8v2H7v2H17V21H13V19h8a2,2,0,0,0,2-2V3A2,2,0,0,0,21,1Zm0,16H3V3H21Z",
    fill: "#343434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationIconGenreEssentials);
export default __webpack_public_path__ + "static/media/navigation-icon-genre-essentials.d65900a3d89b05a6402c5c1c370f7499.svg";
export { ForwardRef as ReactComponent };